import React, { FunctionComponent } from 'react';
import { useStepper } from '../../../../hooks';
import classNames from '../../../../utils/classnames';
import { Button, Text, Box } from '@chakra-ui/react';
import { SharedIconArrowLongDown, SharedIconLoadingCircle } from '../../icons';
import { FormattedMessage } from 'react-intl';

export const StepperSubmit: FunctionComponent<{
  isValidated?: boolean;
  id: number;
  label?: string;
  variant?: 'default' | 'button';
  colorScheme?: 'orange';
  isLastStep?: boolean;
  isLoading?: boolean;
  onStepChange?: () => void;
}> = ({
  isValidated,
  id,
  variant = 'default',
  colorScheme,
  label,
  isLastStep,
  isLoading,
  onStepChange
}) => {
  const { setCurrentStep, setStepActive, setStepValid } = useStepper();

  const submitButtonClasses = classNames(
    'rounded-full w-[4rem] h-[4rem] items-center flex justify-center',
    {
      'bg-orange-500': isValidated,
      'bg-gray-100': !isValidated
    }
  );

  const nextIconColor = isValidated ? 'white' : 'gray.500';
  const loadingIconColor = 'white';

  function setNextStep() {
    //console.log('setNextStep', isValidated, isLastStep);
    requestAnimationFrame(() => {
      setStepValid(id, true);
      if (!isLastStep) setCurrentStep(id + 1);
      setStepActive(id, false);
      if (onStepChange) onStepChange();
    });
  }
  return (
    <Box className={`flex justify-end`}>
      {variant === 'button' && (
        <Box>
          <Button
            colorScheme={`${colorScheme}`}
            isLoading={isLoading}
            type={'submit'}
            isDisabled={!isValidated}
            onClick={setNextStep}>
            {label}
          </Button>
        </Box>
      )}
      {variant === 'default' && (
        <Box className={`my-8 w-fit flex flex-col items-center`}>
          <Text as={`span`}>
            {label ? (
              label
            ) : (
              <FormattedMessage id={`stepper.submit`} defaultMessage={`Ga verder`} />
            )}
          </Text>
          <button
            className={submitButtonClasses}
            type={'submit'}
            disabled={!isValidated}
            onClick={setNextStep}>
            {isLoading ? (
              <SharedIconLoadingCircle color={loadingIconColor} boxSize={10} />
            ) : (
              <SharedIconArrowLongDown color={nextIconColor} boxSize={6} />
            )}
          </button>
        </Box>
      )}
    </Box>
  );
};
